module.exports = __webpack_public_path__ + "img/hr-V-R-2-load-standup-shadow.398f1510.png";